import React, { useState, useEffect, useContext } from "react";
import LayoutWrapper from "../components/LayoutWrapper";
import HeaderBar from "../components/HeaderBar";
import { FaSearch, FaFilter, FaRedo } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { ThemeContext } from "../context/ThemeContext";
import getCurrentSkin from "../utils/getCurrentSkin";

const LedgerMainReport = () => {
  const { isDark, skin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;

  const buttonClass = `bg-${baseColor}-${baseShade}`;
  const hoverClass = `hover:bg-${baseColor}-700`;

  // localStorage values
  const finYearId = localStorage.getItem("finYearId") || "";
  const finYear = localStorage.getItem("finYear") || "";
  const storedBranchId = localStorage.getItem("branchId") || "8";
  const storedBranchType = localStorage.getItem("branchType") || "";
  const storedBranch = localStorage.getItem("branch") || "";
  const userId = localStorage.getItem("userId") || "";

  const initialBranchType =
    storedBranch === "HEAD-OFFICE" || storedBranchType === "HO" ? "HO" : "Branch";

  const commonHeaders = {
    "x-finyearid": finYearId,
    "x-finyear": finYear,
    "x-branchid": storedBranchId,
    "x-branch": storedBranchType || initialBranchType,
    "x-userid": userId,
  };

  const [branchType, setBranchType] = useState(initialBranchType);
  const [branchId, setBranchId] = useState(storedBranchId || "8");
  const [location, setLocation] = useState(
    initialBranchType === "HO" ? "HO" : "BRANCH"
  );
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [supplierEquipment, setSupplierEquipment] = useState("");
  const [vendorType, setVendorType] = useState("");
  const [vehicleMainType, setVehicleMainType] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [equipmentType, setEquipmentType] = useState("");
  const [status, setStatus] = useState("");
  const [vehicleCode, setVehicleCode] = useState("");
  const [store, setStore] = useState("");
  const [supplier, setSupplier] = useState("");
  const [showFilters, setShowFilters] = useState(true);
  const [loading, setLoading] = useState(false);

  const [branchList, setBranchList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [data, setData] = useState([]);

  const apiBranchType = branchType === "HO" ? "HO" : "Branch";
  const payloadBranchType = branchType === "HO" ? "H" : "B";

  useEffect(() => {
    setLoading(true);

    axios
      .get("http://nissi-india.com/api/po_fillDropdowns", {
        params: {
          branchid: branchId || storedBranchId || 8,
          branchtype: apiBranchType,
        },
        headers: commonHeaders,
      })
      .then((res) => {
        const stores = res.data.data?.stores || [];
        const suppliers = res.data.data?.suppliers || [];
        const defaultStoreId = res.data.data?.defaultStoreId;

        setBranchList(stores);
        setSupplierList(suppliers);

        if (defaultStoreId && !store) {
          setStore(defaultStoreId.toString());
          setBranchId(defaultStoreId.toString());
        }
      })
      .catch((err) => {
        console.error("Dropdown fetch failed", err);
        toast.error("Failed to load dropdowns");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [branchType]);

  const handleSearch = () => {
    setLoading(true);

    const payload = {
      branchType: payloadBranchType,
      sessionBranchId: String(storedBranchId || branchId || "8"),
      selectedBranchId: String(store || branchId || storedBranchId || "8"),
      type: supplierEquipment === "Equipment" ? "2" : "1",
      rptTypeInput: "",
      vehcode: vehicleCode || "",
      vtname: vehicleType || "",
      vmaintname: vehicleMainType || "",
      optionHB: equipmentType || "",
      venderType: vendorType || "%",
      supcode: supplier || "",
      fromDate: fromDate || "",
      toDate: toDate || "",
      location: location || "",
      status: status || "",
    };

    console.log("payload", payload);

    axios
      .post("http://nissi-india.com/api/ledger/search", payload, {
        headers: commonHeaders,
      })
      .then((res) => {
        const rows =
          res.data?.sections?.supplier?.rows ||
          res.data?.rows ||
          res.data?.recordset ||
          res.data?.recordsets?.[0] ||
          [];

        setData(rows);
        console.log("response:", res.data);
        toast.success(`Loaded ${rows.length} records`);
      })
      .catch((err) => {
        console.error("Ledger fetch failed", err);
        toast.error("Failed to fetch ledger listing");
        setData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleOpenSubReport = (row) => {
    localStorage.setItem("ledgerSupplier", JSON.stringify(row));
    window.open("/inventory/LedgerSubReport", "_blank", "noopener,noreferrer");
  };

  const handleBranchTypeChange = (value) => {
    setBranchType(value);
    setLocation(value === "HO" ? "HO" : "BRANCH");
    setStore("");
    setData([]);
  };

  const resetFilters = () => {
    setFromDate("");
    setToDate("");
    setSupplierEquipment("");
    setVendorType("");
    setVehicleMainType("");
    setVehicleType("");
    setEquipmentType("");
    setStatus("");
    setVehicleCode("");
    setSupplier("");
    setStore("");
    setBranchId(storedBranchId || "8");
    setLocation(branchType === "HO" ? "HO" : "BRANCH");
    setData([]);
  };

  const EmptyState = () => (
    <div className="flex flex-col items-center justify-center py-16 bg-gray-50 dark:bg-gray-800 rounded-lg border-2 border-dashed border-gray-200 dark:border-gray-700">
      <div className="w-16 h-16 bg-orange-100 dark:bg-orange-900 rounded-lg flex items-center justify-center mb-4">
        <svg
          className="w-8 h-8 text-orange-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
      </div>
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
        No Records Found
      </h3>
      <p className="text-gray-500 dark:text-gray-400 text-center max-w-md">
        Try adjusting your search filters or search with different criteria.
      </p>
    </div>
  );

  return (
    <LayoutWrapper>
      <HeaderBar title="LEDGER MAIN REPORT" />
      <ToastContainer />

      <div
        className={`p-6 mt-6 rounded-2xl shadow-xl border ${
          isDark
            ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
            : "bg-white text-gray-800"
        }`}
      >
        <div className="flex justify-between items-center mb-8">
          <div className="flex items-center gap-4">
            <h1
              className={`text-2xl font-bold ${
                isDark ? "text-white" : "text-gray-900"
              }`}
            >
              Ledger Report Records
            </h1>
            <span className="bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100 px-3 py-1 rounded-full text-sm font-medium">
              {data.filter((row) => row.SupplierName).length} Records
            </span>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => setShowFilters(!showFilters)}
              className={`flex items-center gap-2 px-4 py-2 border rounded-lg transition-colors ${
                isDark
                  ? "border-gray-600 text-white hover:bg-gray-800" +
                    (showFilters ? " bg-gray-800" : "")
                  : "border-gray-300 text-gray-700 hover:bg-gray-50" +
                    (showFilters ? " bg-gray-50" : "")
              }`}
            >
              <FaFilter className="w-4 h-4" />
              {showFilters ? "Hide Filters" : "Show Filters"}
            </button>

            <button
              onClick={() =>
                window.open(`/inventory/LedgerItemWiseReport`, "_blank")
              }
              className={`flex items-center gap-2 ${buttonClass} ${hoverClass} text-white px-4 py-2 rounded transition-colors`}
            >
              <FaSearch /> View Wise
            </button>
          </div>
        </div>

        <div className="mb-6">
          <label
            className={`block text-sm font-medium mb-3 ${
              isDark ? "text-gray-300" : "text-gray-700"
            }`}
          >
            Branch Type
          </label>
          <div className="flex gap-2">
            <button
              onClick={() => handleBranchTypeChange("HO")}
              disabled={storedBranch !== "HEAD-OFFICE" && storedBranchType !== "HO"}
              className={`px-6 py-2 rounded-lg font-medium transition-colors ${
                branchType === "HO"
                  ? `${buttonClass} text-white`
                  : isDark
                  ? "bg-gray-700 text-gray-300"
                  : "bg-gray-100 text-gray-700"
              } ${
                storedBranch !== "HEAD-OFFICE" && storedBranchType !== "HO"
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            >
              Head Office
            </button>
            <button
              onClick={() => handleBranchTypeChange("Branch")}
              disabled={storedBranch === "HEAD-OFFICE" || storedBranchType === "HO"}
              className={`px-6 py-2 rounded-lg font-medium transition-colors ${
                branchType === "Branch"
                  ? `${buttonClass} text-white`
                  : isDark
                  ? "bg-gray-700 text-gray-300"
                  : "bg-gray-100 text-gray-700"
              } ${
                storedBranch === "HEAD-OFFICE" || storedBranchType === "HO"
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            >
              Branch
            </button>
          </div>
        </div>

        {showFilters && (
          <div
            className={`rounded-xl p-6 mb-6 border ${
              isDark
                ? "bg-gray-800 border-gray-700"
                : "bg-gray-50 border-gray-200"
            }`}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div>
                <label
                  className={`block text-sm font-medium mb-2 ${
                    isDark ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  From Date
                </label>
                <input
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                    isDark
                      ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                      : "bg-white border-gray-300 text-gray-900"
                  }`}
                />
              </div>

              <div>
                <label
                  className={`block text-sm font-medium mb-2 ${
                    isDark ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  To Date
                </label>
                <input
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                    isDark
                      ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                      : "bg-white border-gray-300 text-gray-900"
                  }`}
                />
              </div>

              <div>
                <label
                  className={`block text-sm font-medium mb-2 ${
                    isDark ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Supplier/Equipment
                </label>
                <select
                  className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                    isDark
                      ? "bg-gray-700 border-gray-600 text-white"
                      : "bg-white border-gray-300 text-gray-900"
                  }`}
                  value={supplierEquipment}
                  onChange={(e) => setSupplierEquipment(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Supplier">Supplier</option>
                  <option value="Equipment">Equipment</option>
                </select>
              </div>

              {supplierEquipment === "Supplier" && (
                <div>
                  <label
                    className={`block text-sm font-medium mb-2 ${
                      isDark ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Vendor Type
                  </label>
                  <select
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                      isDark
                        ? "bg-gray-700 border-gray-600 text-white"
                        : "bg-white border-gray-300 text-gray-900"
                    }`}
                    value={vendorType}
                    onChange={(e) => setVendorType(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="All">All</option>
                    <option value="Vendor">Vendor</option>
                    <option value="NonVendor">Non Vendor</option>
                  </select>
                </div>
              )}

              {supplierEquipment === "Supplier" && (
                <div>
                  <label
                    className={`block text-sm font-medium mb-2 ${
                      isDark ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Vehicle Code
                  </label>
                  <input
                    type="text"
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                      isDark
                        ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                        : "bg-white border-gray-300 text-gray-900"
                    }`}
                    value={vehicleCode}
                    onChange={(e) => setVehicleCode(e.target.value)}
                    placeholder="Enter vehicle code"
                  />
                </div>
              )}

              {supplierEquipment === "Supplier" && (
                <div>
                  <label
                    className={`block text-sm font-medium mb-2 ${
                      isDark ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Supplier
                  </label>
                  <select
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                      isDark
                        ? "bg-gray-700 border-gray-600 text-white"
                        : "bg-white border-gray-300 text-gray-900"
                    }`}
                    value={supplier}
                    onChange={(e) => setSupplier(e.target.value)}
                  >
                    <option value="">Select</option>
                    {supplierList.map((s) => (
                      <option key={s.fld_supplierid} value={s.fld_supplierid}>
                        {s.fld_suppliername}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {supplierEquipment === "Equipment" && (
                <div>
                  <label
                    className={`block text-sm font-medium mb-2 ${
                      isDark ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Equipment Type
                  </label>
                  <select
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                      isDark
                        ? "bg-gray-700 border-gray-600 text-white"
                        : "bg-white border-gray-300 text-gray-900"
                    }`}
                    value={equipmentType}
                    onChange={(e) => setEquipmentType(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="Hire">Hire</option>
                    <option value="Own">Own</option>
                    <option value="Department">Department</option>
                    <option value="SpareReturn">Spare Return</option>
                    <option value="CrusherPlant">Crusher Plant</option>
                  </select>
                </div>
              )}

              <div>
                <label
                  className={`block text-sm font-medium mb-2 ${
                    isDark ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Branch
                </label>
                <select
                  className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                    isDark
                      ? "bg-gray-700 border-gray-600 text-white"
                      : "bg-white border-gray-300 text-gray-900"
                  }`}
                  value={store}
                  onChange={(e) => {
                    setStore(e.target.value);
                    setBranchId(e.target.value);
                  }}
                >
                  <option value="">Select</option>
                  {branchList.map((b) => (
                    <option key={b.fld_storeid} value={b.fld_storeid}>
                      {b.fld_storename}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label
                  className={`block text-sm font-medium mb-2 ${
                    isDark ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Vehicle Main Type
                </label>
                <select
                  className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                    isDark
                      ? "bg-gray-700 border-gray-600 text-white"
                      : "bg-white border-gray-300 text-gray-900"
                  }`}
                  value={vehicleMainType}
                  onChange={(e) => setVehicleMainType(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="high">High</option>
                  <option value="low">Low</option>
                </select>
              </div>

              <div>
                <label
                  className={`block text-sm font-medium mb-2 ${
                    isDark ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Vehicle Type
                </label>
                <select
                  className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                    isDark
                      ? "bg-gray-700 border-gray-600 text-white"
                      : "bg-white border-gray-300 text-gray-900"
                  }`}
                  value={vehicleType}
                  onChange={(e) => setVehicleType(e.target.value)}
                >
                  <option value="">Select</option>
                </select>
              </div>
            </div>

            <div
              className={`flex justify-between items-center mt-6 pt-4 border-t ${
                isDark ? "border-gray-600" : "border-gray-200"
              }`}
            >
              <button
                onClick={resetFilters}
                className={`flex items-center gap-2 px-4 py-2 font-medium ${
                  isDark
                    ? "text-gray-300 hover:text-white"
                    : "text-gray-600 hover:text-gray-800"
                }`}
              >
                <FaRedo className="w-4 h-4" />
                Clear Filters
              </button>

              <button
                onClick={handleSearch}
                className={`flex items-center gap-2 ${buttonClass} ${hoverClass} text-white px-4 py-2 rounded transition-colors`}
              >
                <FaSearch className="w-4 h-4" />
                Search Records
              </button>
            </div>
          </div>
        )}

        {loading ? (
          <div className="p-8 text-center">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            <p className="mt-2 text-gray-500 dark:text-gray-400">
              Loading data...
            </p>
          </div>
        ) : data.length === 0 ? (
          <EmptyState />
        ) : (
          <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
            <div className="flex justify-between items-center p-4 border-b border-gray-200 dark:border-gray-700">
              <h3 className="font-semibold text-gray-900 dark:text-white">
                Ledger Report Results
              </h3>
              <div className="text-sm text-gray-500 dark:text-gray-400">
                {data.filter((row) => row.SupplierName).length} records found
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                <thead className={`bg-${baseColor}-${baseShade} text-white`}>
                  <tr>
                    <th className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider">
                      S.No
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider">
                      Supplier
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider">
                      Code
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider">
                      Vendor Type
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider">
                      Credit
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider">
                      City
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider">
                      Debit
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider">
                      Cl. Balance
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                  {data
                    .filter((row) => row.SupplierName)
                    .map((row, index) => (
                      <tr
                        key={index}
                        className="hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                      >
                        <td
                          className="px-6 py-4 whitespace-nowrap text-blue-600 dark:text-blue-400 cursor-pointer underline"
                          onClick={() => handleOpenSubReport(row)}
                        >
                          {index + 1}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                          {row.SupplierName}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                          {row.Code}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                          {row.VendorType}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900 dark:text-white">
                          {Number(row.Credit_new || 0).toLocaleString("en-IN", {
                            style: "currency",
                            currency: "INR",
                            minimumFractionDigits: 2,
                          })}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                          {row.City || ""}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900 dark:text-white">
                          {Number(row.Debit_New || 0).toLocaleString("en-IN", {
                            style: "currency",
                            currency: "INR",
                            minimumFractionDigits: 2,
                          })}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900 dark:text-white">
                          {Number(row.Cl_Balance_New || 0).toLocaleString(
                            "en-IN",
                            {
                              style: "currency",
                              currency: "INR",
                              minimumFractionDigits: 2,
                            }
                          )}
                        </td>
                      </tr>
                    ))}

                  <tr className="font-bold bg-gray-200 dark:bg-gray-600">
                    <td
                      className="px-6 py-4 text-center text-gray-900 dark:text-white"
                      colSpan={4}
                    >
                      TOTAL
                    </td>
                    <td className="px-6 py-4 text-right text-gray-900 dark:text-white">
                      {data
                        .reduce(
                          (sum, row) => sum + (Number(row.Credit_new) || 0),
                          0
                        )
                        .toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                          minimumFractionDigits: 2,
                        })}
                    </td>
                    <td className="px-6 py-4"></td>
                    <td className="px-6 py-4 text-right text-gray-900 dark:text-white">
                      {data
                        .reduce(
                          (sum, row) => sum + (Number(row.Debit_New) || 0),
                          0
                        )
                        .toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                          minimumFractionDigits: 2,
                        })}
                    </td>
                    <td className="px-6 py-4 text-right text-gray-900 dark:text-white">
                      {data
                        .reduce(
                          (sum, row) => sum + (Number(row.Cl_Balance_New) || 0),
                          0
                        )
                        .toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                          minimumFractionDigits: 2,
                        })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </LayoutWrapper>
  );
};

export default LedgerMainReport;